import { Component, EventEmitter, HostBinding, OnInit, Output, Input } from '@angular/core';
import { Label } from '../../services/eleview/types/label';
import { FetchElementAllCategoriesResult } from '../../services/eleview/eleview-backface';

@Component({
	selector: 'common-label-drawer',
	templateUrl: './label-drawer.component.html',
	styleUrls: ['./label-drawer.component.scss']
})
export class LabelDrawerComponent implements OnInit {
	editModel = false;
	selectedLabels: Label[] = [];
	editCategory: FetchElementAllCategoriesResult;
	@HostBinding('class.label-drawer') hostClass = true;
	@Output() close = new EventEmitter();
	constructor() {}

	ngOnInit() {
		console.log('start', this.editModel);
	}
	editClick(event: FetchElementAllCategoriesResult) {
		this.editCategory = event;
		this.editModel = true;
	}
}
